module.exports = __webpack_public_path__ + "assets/devices/SMD-426-PG2-0f83ebeaef91a34f2d4c21c61edd413a.svg";